import { AnyAction } from 'redux'
import { USER_ACTION_TYPES } from './user.types'
import {
  signInFailed,
  signUpFailed,
  signOutFailed,
  signOutSuccess,
  signInSuccess,
} from './user.action'
import { UserData } from '../../utils/firebase.utils'

export type UserState = {
  readonly currentUser: UserData | null
  readonly error: Error | null
  readonly isLoading: boolean
}

const INITIAL_STATE: UserState = {
  currentUser: null,
  isLoading: false,
  error: null,
}

export default function userReducer(state = INITIAL_STATE, action: AnyAction) {
  if (signInSuccess.match(action)) {
    return {
      ...state,
      currentUser: action.payload,
    }
  }

  if (signOutSuccess.match(action)) {
    return {
      ...state,
      currentUser: null,
    }
  }

  if (
    signInFailed.match(action) ||
    signUpFailed.match(action) ||
    signOutFailed.match(action)
  ) {
    return {
      ...state,
      error: action.payload,
    }
  }

  return state
}
